// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GaugeChart_primaryMetricLabel__AWP6o {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.GaugeChart_secondaryMetricLabel__nimsS {
  /* position box in the center towards the bottom */
  position: relative;
  top: 60%;
  text-align: center;
  margin: 0 auto;

  /* show ellipsis if text doesn't fit in div or if more than 2 lines */
  line-height: 1.15em;
  display: -webkit-box;
  -webkit-box-orient: vertical; /* Need to add comment below to prevent this attribute from being removed */
  /* autoprefixer: off */
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Chart/GaugeChart/GaugeChart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;;EAEd,qEAAqE;EACrE,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B,EAAE,2EAA2E;EACzG,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".primaryMetricLabel {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.secondaryMetricLabel {\n  /* position box in the center towards the bottom */\n  position: relative;\n  top: 60%;\n  text-align: center;\n  margin: 0 auto;\n\n  /* show ellipsis if text doesn't fit in div or if more than 2 lines */\n  line-height: 1.15em;\n  display: -webkit-box;\n  -webkit-box-orient: vertical; /* Need to add comment below to prevent this attribute from being removed */\n  /* autoprefixer: off */\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryMetricLabel": `GaugeChart_primaryMetricLabel__AWP6o`,
	"secondaryMetricLabel": `GaugeChart_secondaryMetricLabel__nimsS`
};
export default ___CSS_LOADER_EXPORT___;
